import { Component, inject, OnInit } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router'
import { TableModule } from 'primeng/table'
import { TagModule } from 'primeng/tag'
import { CardModule } from 'primeng/card'
import { ButtonModule } from 'primeng/button'
import { TooltipModule } from 'primeng/tooltip'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import {
  DiagnosticDetailResponse,
  DiagnosticEvent,
  OptimizationDiagnosticService,
} from '../../services/optimization-diagnostic.service'

type Severity = 'success' | 'warn' | 'danger' | 'info' | 'secondary'

@Component({
  selector: 'app-optimization-diagnostic-detail',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    TableModule,
    TagModule,
    CardModule,
    ButtonModule,
    TooltipModule,
    ProgressSpinnerModule,
  ],
  templateUrl: './optimization-diagnostic-detail.component.html',
  styleUrl: './optimization-diagnostic-detail.component.scss',
})
export class OptimizationDiagnosticDetailComponent implements OnInit {
  private service = inject(OptimizationDiagnosticService)
  private router = inject(Router)
  private route = inject(ActivatedRoute)

  public loading$ = this.service.detailLoading$
  public data: DiagnosticDetailResponse | null = null
  public copied = false

  private runId?: number

  ngOnInit() {
    const affairId = Number(this.route.snapshot.paramMap.get('affairId'))
    const runParam = this.route.snapshot.queryParamMap.get('runId')
    this.runId = runParam ? Number(runParam) : undefined
    this.service.getAffairDiagnostic(affairId, this.runId).subscribe((res) => {
      this.data = res
    })
  }

  back() {
    this.router.navigate(
      ['/admin/optimization-diagnostic'],
      this.runId ? { queryParams: { runId: this.runId } } : {}
    )
  }

  copyMapsQuery() {
    const a = this.data?.affair
    const text = a?.mapsQuery ?? this.coordsString()
    if (!text) return
    navigator.clipboard.writeText(text).then(() => {
      this.copied = true
      setTimeout(() => (this.copied = false), 1500)
    })
  }

  openMaps() {
    const a = this.data?.affair
    const query = a?.mapsQuery ?? this.coordsString()
    if (!query) return
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`,
      '_blank'
    )
  }

  openRedirect() {
    const url = this.data?.affair?.redirectUrl
    if (url) window.open(url, '_blank')
  }

  private coordsString(): string | null {
    const a = this.data?.affair
    return a && a.latitude != null && a.longitude != null
      ? `${a.latitude},${a.longitude}`
      : null
  }

  detailString(event: DiagnosticEvent): string | null {
    if (!event.detail) return null
    try {
      return JSON.stringify(event.detail)
    } catch {
      return null
    }
  }

  reasonSeverity(code: string | null): Severity {
    switch (code) {
      case 'missing_coords':
      case 'no_tech_in_radius':
      case 'no_tech_with_skills':
      case 'vroom_unroutable':
      case 'vroom_error':
        return 'danger'
      case 'deadline_passed':
      case 'no_tech_available':
      case 'unassigned':
        return 'warn'
      case 'crowded_out':
        return 'info'
      default:
        return 'secondary'
    }
  }
}
